const NAME = 'QUALAROO';
const CNameMapping = {
  [NAME]: NAME,
  Qualaroo: NAME,
  qualaroo: NAME,
};

export { NAME, CNameMapping };
